<template>
  <Header></Header>
  <SideBar></SideBar>
  <Body pageTitle="Setting" class="app-options">
    <template v-slot:body>
      <slot name="body"> </slot>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
export default {
  components: {
    Header,
    SideBar,
    Body
  }
}
</script>

<style lang="scss">
.app-options {
  .card-header {
    padding: 0.75rem 1.25rem;
  }
  .card-title {
    margin-bottom: 0 !important;
    margin-top: 10px !important;
  }
  .flags {
    li {
      max-width: 60px;
    }
  }
  .select-list {
    .checkbox-container {
      display: inline-block;
      margin: 5px;
      background: #eee;
      .checkmark {
        padding: 3px 10px;
        margin-right: 0;
      }
      input {
        &:checked ~ .checkmark {
          color: #fff;
          background-color: #2196f3;
        }
      }
    }
  }
  .radio-container,
  .checkbox-container {
    input {
      &:checked ~ .checkmark {
        background-color: #2651be;
      }
    }
  }
}
</style>
